jQuery(document).ready(function ($) {
  if (window.innerWidth > 1023) {
    $('[data-usd-equaliser]').each(function () {
      const watchedHeight = $(this)
        .find('[data-usd-watch]')
        .outerHeight()

      $(this)
        .find('[data-usd-equalise]')
        .height(watchedHeight)
    })
  }
})
